module.exports = __webpack_public_path__ + "static/media/Rounds-01.012c08ba.png";